import { type ElementType, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

type CardPadding = 'none' | 'sm' | 'md' | 'lg';
type CardVariant = 'solid' | 'dashed';

const PADDING_CLASS: Record<CardPadding, string> = {
  none: '',
  sm: 'p-5',
  md: 'p-6',
  lg: 'p-8',
};

interface CardProps {
  children: ReactNode;
  padding?: CardPadding;
  variant?: CardVariant;
  shadow?: boolean;
  as?: ElementType;
  className?: string;
}

export function Card({
  children,
  padding = 'sm',
  variant = 'solid',
  shadow = true,
  as,
  className,
}: CardProps) {
  const Component = as === undefined ? 'div' : as;
  return (
    <Component
      className={cn(
        'bg-zoowhite rounded-2xl border',
        variant === 'dashed' ? 'border-dashed border-zoopalelavender' : 'border-zooborder',
        shadow === true ? 'shadow-sm' : '',
        PADDING_CLASS[padding],
        className
      )}
    >
      {children}
    </Component>
  );
}
